/**
 * Resolves the i18n bundle to use for a company country, given the user's base language ("fr" | "en").
 * Country bundles only override a few keys and fall back to their base language (see i18n.js).
 */
export const resolveCountryLanguage = (countryCode: string | undefined, language: string): string => {
    switch (countryCode) {
        case "fr-BE":
            return language === "fr" ? "fr-BE" : language;
        case "fr-CA":
            return language === "en" ? "en-CA" : "fr-CA";
        // UK and India are English-only, regardless of user preference
        case "en-UK":
            return "en-UK";
        case "en-IN":
            return "en-IN";
        case "en-GR":
            return language === "fr" ? "fr-GR" : "en-GR";
        default:
            return language;
    }
};
